import "./styles/globals.css";
import App from "./App";
import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";
import { store, persistor } from "../store/store"; // Import store and persistor
import { OfficeWrapper } from "./components/OfficeWrapper";
import { PersistGate } from "redux-persist/integration/react"; // Import PersistGate
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { UserProvider } from "./components/auth-provider";

const queryClient = new QueryClient();

Office.onReady((info) => {
	if (info.host === Office.HostType.Word) {
		const rootElement = document.getElementById("root");
		const root = createRoot(rootElement);
		root.render(
			<QueryClientProvider client={queryClient}>
				<Provider store={store}>
					<PersistGate loading={null} persistor={persistor}>
						<OfficeWrapper>
							<UserProvider>
								<App />
							</UserProvider>
						</OfficeWrapper>
					</PersistGate>
				</Provider>
			</QueryClientProvider>
		);
	}
});
